// @ts-ignore
import React, {useEffect, useState, useRef, useMemo} from 'react'
import {togglePopover} from "../../../app/app-slice";
import {PanelFooter, PanelPopover} from "../../../shared";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {Button} from "../../../ui-components";
import './styles.scss'
import {CircleGradientIcon, FemaleIcon, RouteIcon} from "../../../assets";
import {customerErInterested} from "../../requests/er-thunk";
import {requestClosed} from '../../../services/utils';
import CustomerDpInfo from "../CustomerDpInfo";
import BrigadeInfo from "../../brigade/brigadeInfo";
import DpOffersList from "./DpOffersList";
import BrigadeForm from "./brigade-form";
import DpCancelOffer from "./DpCancelOffer";
// @ts-ignore
import DpEmergencyPatientInfo from "../../emergencyCall/DpEmergencyComponents/DpEmergencyPatientInfo"
import DpScheduledPatientInfo from "../../scheduledCall/DpScheduledComponents/DpScheduledPatientInfo"
import DpDestinations from "../../scheduledCall/DpScheduledComponents/DpDestinations"
import CustomerReplaceHospitalForm from "../DcComponents/customerReplace-hospital-form";
import BrigadeFormEmergency from "../../emergencyCall/DpRequestComponents/brigade-form";
import BrigadeFormScheduled from "../../scheduledCall/DpScheduledComponents/brigade-form";
import PayInfoDp from "../DpComponents/PayInfoDp";
const DpNewRequest = () => {
  const [formList, setFormList] = useState<any>([{brigade_type: '', eta: '', price: ""}])
  const [formListEmergency, setFormListEmergency] = useState<any>([{brigade_type: '', brigade_hours: '0', brigade_minutes: '0', price: "", price_hospitalization: "", hourly: false, distance: "", distance_price: "", isDistance: false }])
  const [formListScheduled, setFormListScheduled] = useState<any>([{brigade_type: '', brigade_hours: '0', brigade_minutes: '0', price: "", distance: "", distance_price: "", isDistance: false }])
  const [dataEmpty, setDataEmpty] = useState<boolean>(false)
  const [dataEmptyEmergency, setDataEmptyEmergency] = useState<boolean>(false)
  const [dataEmptyScheduled, setDataEmptyScheduled] = useState<boolean>(false)
  const [clickDisabled, setClickDisabled] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const app = useAppSelector(state => state.app)
  const {request, pool, er_call} = useAppSelector(state => state.requests)
  const offersRef = useRef(null)
  useEffect(() => {
    const res = formList.map(el => Object.values(el).some(val => !val))
    setDataEmpty(res.some(el => el === true))
  }, [formList])
  useEffect(() => {
    const res = formListEmergency.map(el => {
      const isHourly = el.hourly;
      const excludedFields = [
        'hourly',
        'distance_price',
        'isDistance',
        'distance',
        ...(isHourly ? ['price_hospitalization'] : [])
      ];
      return Object.entries(el)
        .filter(([key]) => !excludedFields.includes(key))
        .some(([_, val]) => val === '' || val === null || val === undefined);
    });
    setDataEmptyEmergency(res.some(Boolean));
  }, [formListEmergency]);
  useEffect(() => {
    const excludedFields = ['distance_price', 'isDistance', 'distance'];
    const res = formListScheduled.map(el =>
      Object.entries(el)
        .filter(([key]) => !excludedFields.includes(key))
        .some(([_, val]) => val === '' || val === null || val === undefined)
    );
    setDataEmptyScheduled(res.some(Boolean))
  }, [formListScheduled])
  const setData = (key, value, index) => {
    const list = [...formList]
    list[index][key] = value
    setFormList(list)
  }
  // const setDataEmergency = (key, value, index) => {
  //   const list = [...formListEmergency]
  //   list[index][key] = value
  //   setFormListEmergency(list)
  // }

  const setDataEmergency = (key, value, index) => {
    const list = [...formListEmergency];
    const item = { ...list[index], [key]: value };

    if (key === 'hourly' && value === true) {
      item.price_hospitalization = ''; // Clear value
    }

    list[index] = item;
    setFormListEmergency(list);
  };


  const setDataScheduled = (key, value, index) => {
    const list = [...formListScheduled]
    list[index][key] = value
    setFormListScheduled(list)
  }
  const addForm = async () => {
    const list = [...formList]
    list.push({
      brigade_type: '',
      price: "",
      eta: ''
    })
    await setFormList(list)
    setScroll()
  }
  const addFormEmergency = async () => {
    const list = [...formListEmergency]
    list.push({
      brigade_type: '',isDistance: false, brigade_hours: '0', brigade_minutes: '0', price: "", price_hospitalization: "", hourly: false, distance: "", distance_price: "",
    })
    await setFormListEmergency(list)
    setScroll()
  }
const addFormScheduled = async () => {
    const list = [...formListScheduled]
    list.push({
      brigade_type: '',isDistance: false, brigade_hours: '0', brigade_minutes: '0', price: "",  distance: "", distance_price: "",
    })
    await setFormListScheduled(list)
    setScroll()
  }

  const setScroll = () => {
    const container: any = offersRef.current
    container.querySelectorAll('div #panel-popover')[0].scrollTop = container.querySelectorAll('div #panel-popover')[0].scrollHeight
  }
  const removeForm = (idx: number) => {
    const list = [...formList]
    list.splice(idx, 1)
    setFormList(list)
  }

  const removeFormEmergency = (idx: number) => {
    const list = [...formListEmergency]
    list.splice(idx, 1)
    setFormListEmergency(list)
  }
  const removeFormScheduled = (idx: number) => {
    const list = [...formListScheduled]
    list.splice(idx, 1)
    setFormListScheduled(list)
  }

  const selectedRequestBrigade = useMemo(() => {
    if (request) {
      return request?.requestedBrigades?.filter((b) => b.request_uuid === request?.uuid)
    }
  }, [request])


  return (
    <div id='new-request' className='request-info-container pb-80'>
      {pool && pool.request_brigade && <DpOffersList/>}
      <PayInfoDp/>
      {request?.type ===3 && <CustomerDpInfo/>}
      {request && request.type ===3 && request?.requestedBrigades && selectedRequestBrigade.map((item) => {
        return <BrigadeInfo br={item}/>
      })}
      {request && request.type ===1 && <DpEmergencyPatientInfo br={request}/>}
      {request && request.type ===2 && <DpScheduledPatientInfo br={request}/>}
      {request && request.type ===2 && <div>
          <div style={{display: "flex", marginTop: 6, alignItems: "center"}}>
            <RouteIcon  className='mr-5'/>
            <div style={{    fontFamily: "Manrope Semibold",
              color: "rgb(25, 34, 51)",
              fontSize: 16,
              fontWeight: 700,
              overflowWrap: "break-word"}}>Пункт назначения</div>
        </div>
        <>
          {request.destination.map((d, index) => {
            return <DpDestinations d={d} index={index}/>
          })}
      </>
      </div>}
      {!requestClosed(request?.status) &&pool?.status !== 3 &&
        <PanelFooter className='footer'>
          <div style={{display: "flex", gap: 12, width: "100%"}}>
          <Button onClick={() => {
            if (er_call && er_call.status === 1) {
              dispatch(togglePopover('acceptFormOpen'))
            }else {
              dispatch(togglePopover('offerFormOpen'))
            }
          }}
                  className='offer-button'
                  type='contained'>{er_call && er_call.status === 1 ? "Назначить Бригаду": pool && pool?.status === 1 ? "Отправитъ Предложение" : "Доп. Предложение"}</Button>
          <Button onClick={() => {dispatch(togglePopover('dpCancelOffer'))}}
                  className='offer-button'
                  type='outlined'>Отказ от заявки</Button>
          </div>
        </PanelFooter>}
      {request && request.type ===3 && <div ref={offersRef}>
        <PanelPopover open={app.popoverFormStatuses.offerFormOpen}
                      handleClose={() => dispatch(togglePopover('offerFormOpen'))}
                      title={'Создатъ предложение'}>
          {formList.map((el, i) => <BrigadeForm brigade_type={el.brigade_type}
                                                listCount={formList.length}
                                                price={el.price}
                                                handleFormRemove={() => removeForm(i)}
                                                key={i}
                                                handleInputChange={(key, value) => setData(key, value, i)}
                                                eta={el.eta}/>)}

          <div className='offer-form-footer'>
            <p className='add-btn' onClick={addForm}><CircleGradientIcon/>Добавить</p>
            {pool?.status !== 3 && <Button type='contained' disabled={dataEmpty} fullWidth
                                           onClick={() => {
                                             setClickDisabled(true)
                                             dispatch(customerErInterested(formList))
                                               .then(res => setClickDisabled(false))
                                           }}
                                           className={`send-btn ${clickDisabled ? 'click-disabled' : ''}`}>Отправитъ
              Предложение</Button>}
          </div>
        </PanelPopover>
        <PanelPopover title={'Отказ'}
                      open={app.popoverFormStatuses.dpCancelOffer}
                      handleClose={() => dispatch(togglePopover('dpCancelOffer'))}>
          <DpCancelOffer request={request}/>
        </PanelPopover>
      </div>}




      {request && request.type ===1 && <div ref={offersRef}>
        <PanelPopover open={app.popoverFormStatuses.offerFormOpen}
                      handleClose={() => dispatch(togglePopover('offerFormOpen'))}
                      title={'Создатъ предложение'}>
          {formListEmergency.map((el, i) => <BrigadeFormEmergency
                                                brigade_type={el.brigade_type}
                                                listCount={formListEmergency.length}
                                                price={el.price}
                                                price_hospitalization={el.price_hospitalization}
                                                brigade_hours={el.brigade_hours}
                                                brigade_minutes={el.brigade_minutes}
                                                hourly={el.hourly}
                                                isDistance={el.isDistance}
                                                distance_price={el.distance_price}
                                                distance={el.distance}
                                                handleFormRemove={() => removeFormEmergency(i)}
                                                key={i}
                                                handleInputChange={(key, value) => setDataEmergency(key, value, i)}
                                                />)}

          <div className='offer-form-footer'>
            <p className='add-btn' onClick={addFormEmergency}><CircleGradientIcon/>Добавить</p>
            {pool?.status !== 3 && <Button type='contained' disabled={dataEmptyEmergency} fullWidth
                                           onClick={() => {
                                             setClickDisabled(true)
                                             dispatch(customerErInterested(formListEmergency))
                                               .then(res => setClickDisabled(false))
                                           }}
                                           className={`send-btn ${clickDisabled ? 'click-disabled' : ''}`}>Отправитъ
              Предложение</Button>}
          </div>
        </PanelPopover>
        <PanelPopover title={'Отказ'}
                      open={app.popoverFormStatuses.dpCancelOffer}
                      handleClose={() => dispatch(togglePopover('dpCancelOffer'))}>
          <DpCancelOffer request={request}/>
        </PanelPopover>
      </div>}


      {request && request.type ===2 && <div ref={offersRef}>
        <PanelPopover open={app.popoverFormStatuses.offerFormOpen}
                      handleClose={() => dispatch(togglePopover('offerFormOpen'))}
                      title={'Создатъ предложение'}>
          {formListScheduled.map((el, i) => <BrigadeFormScheduled
            brigade_type={el.brigade_type}
            listCount={formListScheduled.length}
            price={el.price}
            brigade_hours={el.brigade_hours}
            brigade_minutes={el.brigade_minutes}
            isDistance={el.isDistance}
            distance_price={el.distance_price}
            distance={el.distance}
            handleFormRemove={() => removeFormScheduled(i)}
            key={i}
            handleInputChange={(key, value) => setDataScheduled(key, value, i)}
          />)}

          <div className='offer-form-footer'>
            <p className='add-btn' onClick={addFormScheduled}><CircleGradientIcon/>Добавить</p>
            {pool?.status !== 3 && <Button type='contained' disabled={dataEmptyScheduled} fullWidth
                                           onClick={() => {
                                             setClickDisabled(true)
                                             dispatch(customerErInterested(formListScheduled))
                                               .then(res => setClickDisabled(false))
                                           }}
                                           className={`send-btn ${clickDisabled ? 'click-disabled' : ''}`}>Отправитъ
              Предложение</Button>}
          </div>
        </PanelPopover>
        <PanelPopover title={'Отказ'}
                      open={app.popoverFormStatuses.dpCancelOffer}
                      handleClose={() => dispatch(togglePopover('dpCancelOffer'))}>
          <DpCancelOffer request={request}/>
        </PanelPopover>
      </div>}
    </div>
  )
}

export default DpNewRequest
